// New Listings
export const QP_NEW_LISTINGS = 'latest';
export const QP_NEW_LISTINGS_VALUE_ENABLED = 'true';

// Page size
export const QP_PAGE_SIZE = 'pageSize';
export const QP_PAGE_SIZE_VALUE_DEFAULT = 60;
export const QP_PAGE_SIZE_VALUE_MAX = 120;

// Page count
export const QP_PAGE = 'page';
export const DISPLAY_MAX_NUMBER_OF_PAGES = 50;

// Content Module Preview ID
export const QP_CONTENT_MODULE_ID = '_content:modules';

export const QP_PERSONALIZED_FILTER_VALUE_SHIPPING_FREE = 'shipping-free';
export const QP_PERSONALIZED_FILTER_VALUE_WHITE_GLOVE_SHIPPING = 'white-glove-shipping';

export const QP_PERSONALIZED_FILTER = 'personalizedfilter';

export const QP_SEARCH_QUERY = 'q';
